import { combine, persist } from 'zustand/middleware';
import { createWithEqualityFn as create } from 'zustand/traditional';

const initialJobsTasksState: any = {
  current_page: 0,
  first_page_url: '',
  from: 0,
  last_page: 0,
  last_page_url: '',
  next_page_url: '',
  path: '',
  per_page: '',
  to: 0,
  total: 0,
};

const jobsTasksStore = combine({ jobsTasksState: initialJobsTasksState, jobsTasksRedirected: false }, set => ({
  updateJobsTasksState: (newJobsTasksState: any) => {
    set(() => ({ jobsTasksState: newJobsTasksState }));
  },
  jobsTasksHasRedirected: () => set(() => ({ jobsTasksRedirected: true })),
  jobsTasksHasNotRedirected: () => set(() => ({ jobsTasksRedirected: false })),
  clearJobsTasksState: () =>
    set(() => ({
      jobsTasksState: initialJobsTasksState,
    })),
}));

export const useJobsTasksStore = create(persist(jobsTasksStore, { name: 'jobsTasksState' }));
